import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useMainSectionParameter } from 'components/Dashboard/helpers/useMainSectionParameter';
import InboxBar from './InboxBar';
import SearchResultsBar from './SearchResultsBar';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import { store } from 'components/Store';
import { useLocation } from 'react-router';
import MainListActionsBar from 'components/Dashboard/SubNav/MainListActionsBar';
import AddUpdatesToReport from 'components/Dashboard/SubNav/ui/AddUpdatesToReport';
import { ReportsPopup } from 'components/Dashboard/Navigation/NotFeaturePopups';
const SubNav = (props) => {
  const globalState = useContext(store);
  const { dispatch, state } = globalState;

  const { createReportFromUpdatePopup, selectedUpdates, activePlan } = state ?? {};
  const [isOpenReportPopup, setIsOpenReportPopup] = useState(false);
  const [isOpenLoggedOut, setIsOpenLoggedOut] = useState(false);
  const [singleUpdate, setSingleUpdate] = useState(null);
  const [reportModalKey, setReportModalKey] = useState(0);

  const { enableReports } = activePlan ?? {};

  const location = useLocation();
  const { inboxSection, referenceSection, searchResultsSection } = useMainSectionParameter();
  const memoryMasterTopic = useRef(null);
  memoryMasterTopic.current = () => {
    if (location.pathname.includes('/monitor-inbox')) {
      let memory = getUrlParam('topic-id') === 'all';
      dispatch({ type: 'MODIFY_SECTION', parameter: 'memoryMasterTopic', value: memory });
    }
  };

  useEffect(() => {
    memoryMasterTopic.current();
  }, [location.search]);

  useEffect(() => {
    if (createReportFromUpdatePopup?.open && !isOpenReportPopup) {
      if (enableReports) {
        setIsOpenReportPopup(true);
      } else {
        setIsOpenLoggedOut(true);
      }
      setSingleUpdate(createReportFromUpdatePopup?.update);
    }
  }, [createReportFromUpdatePopup]);

  // Synchronously null out the store before paint so stale open-state never survives navigation.
  useLayoutEffect(() => {
    return () => {
      dispatch({ type: 'MODIFY_SECTION', parameter: 'createReportFromUpdatePopup', value: null });
    };
  }, [location.pathname]);

  // Force a fresh react-modal mount on every open, regardless of which dispatch site triggered it.
  useLayoutEffect(() => {
    if (createReportFromUpdatePopup?.open) {
      setReportModalKey((prev) => prev + 1);
    }
  }, [createReportFromUpdatePopup]);

  const NON_REPORTABLE_TYPES = ['RegulationDocumentComment', 'RegulationDocket'];
  const reportableUpdates = selectedUpdates?.filter((item) => !NON_REPORTABLE_TYPES.includes(item?.type)) ?? [];
  const updatesToSend = singleUpdate ? [singleUpdate] : reportableUpdates;

  return (
    <>
      <div className='position-relative'>
        <MainListActionsBar
          setIsOpenReportPopup={setIsOpenReportPopup}
          setIsOpenLoggedOut={setIsOpenLoggedOut}
          hasReportableUpdates={reportableUpdates.length > 0}
        />
        {inboxSection && <InboxBar />}
        {(searchResultsSection || referenceSection) && <SearchResultsBar />}

      </div>
      <AddUpdatesToReport
        key={reportModalKey}
        selectedUpdates={updatesToSend}
        setSingleUpdate={setSingleUpdate}
        isOpen={isOpenReportPopup}
        setIsOpen={setIsOpenReportPopup}
        fromMainList={true}
      />

      <ReportsPopup isOpen={isOpenLoggedOut} setIsOpen={setIsOpenLoggedOut} />
    </>
  );
};

export default SubNav;
